module.exports = __webpack_public_path__ + "img/3.64e20d9f.svg";